import { render, staticRenderFns } from "./LockedProfile.vue?vue&type=template&id=4baecdde&scoped=true&"
import script from "./LockedProfile.vue?vue&type=script&lang=js&"
export * from "./LockedProfile.vue?vue&type=script&lang=js&"
import style0 from "./LockedProfile.vue?vue&type=style&index=0&id=4baecdde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baecdde",
  null
  
)

export default component.exports